import ball from "./../sounds/ball.ogg";
import bike from "./../sounds/bike.ogg";
import boat from "./../sounds/boat.ogg";
import car from "./../sounds/car.ogg";
import doll from "./../sounds/doll.ogg";
import helicopter from "./../sounds/helicopter.ogg";
import kite from "./../sounds/kite.ogg";
import plane from "./../sounds/plane.ogg";
import rocket from "./../sounds/rocket.ogg";
import scooter from "./../sounds/scooter.ogg";
import teddy from "./../sounds/teddy.ogg";
import train from "./../sounds/train.ogg";
import castle from "./../sounds/castle.ogg";
import puzzle from "./../sounds/puzzle.ogg";

export const toys = [
    {
      title: "ball",
      polish: "piłka",
      image:
        "https://images.unsplash.com/photo-1575361204480-aadea25e6e68?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=751&q=80",
        sounds: ball,
    },
    {
      title: "bike",
      polish: "rower",
      image:
        "https://images.unsplash.com/photo-1485965120184-e220f721d03e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80",
        sounds: bike,
    },
    {
      title: "boat",
      polish: "łódź",
      image:
        "https://images.unsplash.com/photo-1545566239-0b2fb5c50bc6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80",
        sounds: boat,
    },
    {
      title: "car",
      polish: "samochód",
      image:
        "https://images.unsplash.com/photo-1532974297617-c0f05fe48bff?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=700&q=80",
        sounds: car,
    },
    {
      title: "doll",
      polish: "lalka",
      image:
        "https://cdn.pixabay.com/photo/2019/03/17/19/58/doll-4061815_1280.jpg",
        sounds: doll,
    },
    {
      title: "helicopter",
      polish: "helikopter",
      image:
        "https://images.unsplash.com/photo-1563561686990-f0ef5b3e0b7c?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=667&q=80",
        sounds: helicopter,
    },
    {
      title: "kite",
      polish: "latawiec",
      image:
        "https://cdn.pixabay.com/photo/2016/01/24/19/55/kite-1159538_1280.jpg",
        sounds: kite,
    },
    {
      title: "plane",
      polish: "samolot",
      image:
        "https://images.unsplash.com/photo-1468530986413-2c93495ed020?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=749&q=80",
        sounds: plane,
    },
    {
        title: "rocket",
        polish: "rakieta",
        image:
          "https://images.unsplash.com/photo-1596741964346-791466b552b6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=634&q=80",
          sounds: rocket,
      },
      {
        title: "scooter",
        polish: "hulajnoga",
        image:
          "https://images.unsplash.com/photo-1597260491619-bab87197869f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=562&q=80",
          sounds: scooter,
      },
      {
        title: "teddy",
        polish: "pluszowy miś",
        image:
          "https://images.unsplash.com/photo-1543886151-3bc2b944c718?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80",
          sounds: teddy,
      },
      {
        title: "train",
        polish: "pociąg",
        image:
          "https://cdn.pixabay.com/photo/2013/10/02/15/19/train-189828_1280.jpg",
          sounds: train,
      },
      {
        title: "castle",
        polish: "zamek",
        image:
          "https://cdn.pixabay.com/photo/2014/11/15/23/29/fairytale-532850_1280.jpg",
          sounds: castle,
      },
      {
        title: "puzzle",
        polish: "klocki / puzzle",
        image:
          "https://images.unsplash.com/photo-1541692641319-981cc79ee10a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=750&q=80",
          sounds: puzzle,
      },
  ];
